var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.311704 0.311704C0.72731 -0.103901 1.40114 -0.103901 1.81675 0.311704L7.5 5.995L13.1833 0.311704C13.5669 -0.0719318 14.1706 -0.101442 14.588 0.223173L14.6883 0.311704C15.1039 0.72731 15.1039 1.40114 14.6883 1.81675L9.005 7.5L14.6883 13.1833C15.0719 13.5669 15.1014 14.1706 14.7768 14.588L14.6883 14.6883C14.2727 15.1039 13.5989 15.1039 13.1833 14.6883L7.5 9.005L1.81675 14.6883C1.43311 15.0719 0.829449 15.1014 0.411962 14.7768L0.311704 14.6883C-0.103901 14.2727 -0.103901 13.5989 0.311704 13.1833L5.995 7.5L0.311704 1.81675C-0.0719318 1.43311 -0.101442 0.829449 0.223173 0.411962L0.311704 0.311704Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.0d7dae05af62bb8ba0881a12a0bdaa13.svg";
export { ForwardRef as ReactComponent };